import * as React from 'react';

import './BeachMatchSeriesOverview.scss';
import { NavLink, useParams } from 'react-router-dom';
import { getBeachMatchSeriesPath } from '../../utils';
import { BeachRootState } from '../../';
import { connect } from 'react-redux';
import { BeachMatchSeriesView } from './BeachMatchSeriesView';

const mapStateToProps = (state: BeachRootState) => {
  return {
    matchSeriesByUuid: state.tickerState.matchSeries, 
    matchStatesByUuid: state.tickerState.matchStatesByUuid,
    hierarchies: state.tickerState.hierarchies,
    matchDays: state.tickerState.matchDays,
    dayFilter: state.dayFilter,
    filterNav: state.filterNav
  }
}

type Props = ReturnType<typeof mapStateToProps>

const BeachMatchSeriesOverview = (props: Props) => {

    const {
      matchSeriesByUuid,
      matchStatesByUuid,
      hierarchies,
      matchDays,
      dayFilter,
      filterNav
    } = props

    const params = useParams()
    const { hierarchyId } = params
    const selectedHierarchy = hierarchies.find(h => h.id === hierarchyId)

    const matchDay = matchDays[dayFilter.activeFilterDay || 0]
    const gender = filterNav.gender

    const matchSeriesList = Object.values(matchSeriesByUuid)
        .filter(matchSeries => !selectedHierarchy || (matchSeries.hierarchy === selectedHierarchy?.id))
        .filter(matchSeries => matchDay.matches.find(match => match.matchSeries === matchSeries.id))
        .filter(matchSeries => !gender || (matchSeries.gender === gender))

    return (
      <div className='BeachMatchSeriesOverview'>
        { selectedHierarchy && <NavLink className="BeachMatchSeriesLink" to={'/'}>zur Übersicht</NavLink>}
        { selectedHierarchy
          ? <div className="SelectedHierarchy">{selectedHierarchy.name} {gender && (gender === 'FEMALE' ? "Damen" : (gender === 'MALE' ? 'Herren' : 'Mixed'))}</div>
          : <div className="SelectedHierarchy">{gender && (gender === 'FEMALE' ? "Damen" : (gender === 'MALE' ? 'Herren' : 'Mixed'))}</div>
        }
        { matchSeriesList.length === 0
          ? <h1 style={{ "padding": "50px" }}>An diesem Tag finden keine Turniere statt.</h1>
          : <div className="BeachMatchSeriesList">{matchSeriesList
          .map(matchSeries => <NavLink className="BeachMatchSeriesLink" key={matchSeries.id} to={getBeachMatchSeriesPath(matchSeries)}>
            <BeachMatchSeriesView matchSeries={matchSeries} matchStatesByUuid={matchStatesByUuid} matchDay={matchDay}></BeachMatchSeriesView>
          </NavLink>)}
          </div>
        }
      </div>
    )
}

export default connect(mapStateToProps)(BeachMatchSeriesOverview)
